import Loader from "@Common/Loader";
import { useAbTestComponent, loadUsualComponent } from "@hook";
import { inject, observer } from "mobx-react";
import AB_3274 from "./AB_3274";
import Default from "./Default";

const abTests = {
    dev_3274__v2: loadUsualComponent(AB_3274),
    dev_3632__v2: loadUsualComponent(AB_3274),
};

const Main = inject("mainStore")(
    observer(({ mainStore, ...props }) => {
        const init = mainStore.getMainStore("init");
        const Specified = useAbTestComponent({ init, abTests, defaultComponent: Default, LoadingComp: Loader }); // лоадер по дефолту можно не передавать. нужен на момент загрузки компонента аб-теста. подходит когда модалки грузим в самом начале приветственные

        return <Specified {...props} />;
    }),
);

export default Main;
